'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COURSE_SUBSCRIPTION_TIERS = undefined;

var _freeze = require('babel-runtime/core-js/object/freeze');

var _freeze2 = _interopRequireDefault(_freeze);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var COURSE_SUBSCRIPTION_TIERS = exports.COURSE_SUBSCRIPTION_TIERS = (0, _freeze2.default)({
  FREE: 'FREE',
  PREMIUM: 'PREMIUM'
});